import { formatApiError } from '@/lib/format-api-error';

export const SENDER_TWO_FACTOR_MASS_SEND_MESSAGE =
	'Аккаунт с 2FA не поддерживается для рассылки; используйте сессию без 2FA или landing auth pipeline';

const SENDER_ERROR_MESSAGES: Record<string, string> = {
	'Sender disabled': 'Модуль sender отключён администратором',
	'Feature disabled': 'Модуль sender отключён',
	'proxy_pool_exhausted': 'Нет свободных прокси для входа — обратитесь к администратору',
	'proxy list is empty': 'Прокси не настроены — обратитесь к администратору',
	'internal error': 'Внутренняя ошибка sender — повторите позже',
	'invalid buildId': 'Некорректный идентификатор сборки',
	'Invalid buildId': 'Некорректный идентификатор сборки',
	'invalid apk file': 'Файл сборки не является корректным APK',
	'Build not found': 'Сборка не найдена или APK ещё не готов',
	'Build sync to sender failed': 'Сборка не появилась в рассылке после отправки APK',
};

export function formatSenderApiError(data: unknown, status?: number): string {
	if (status === 413) {
		return 'Файл слишком большой';
	}

	if (typeof data === 'string' && data.trim()) {
		const trimmed = data.trim();
		const mapped = SENDER_ERROR_MESSAGES[trimmed];
		if (mapped) return mapped;
		if (status === 500) {
			return 'Внутренняя ошибка sender — повторите позже';
		}
		return trimmed;
	}

	const raw = formatApiError(data);
	if (raw) {
		const lower = raw.toLowerCase();
		if (lower.includes('two factor') || lower.includes('two_factor')) {
			return SENDER_TWO_FACTOR_MASS_SEND_MESSAGE;
		}
		if (lower.includes('invalid login code')) {
			return 'Неверный код';
		}
		if (lower.includes('code expired')) {
			return 'Код истёк — запросите новый';
		}
		if (lower.includes('flood wait')) {
			return 'Слишком много попыток — подождите и повторите';
		}
		if (lower.includes('proxy_pool_exhausted') || lower.includes('proxy pool')) {
			return SENDER_ERROR_MESSAGES['proxy_pool_exhausted'];
		}
		if (lower.includes('proxy list is empty')) {
			return SENDER_ERROR_MESSAGES['proxy list is empty'];
		}
		const mapped = SENDER_ERROR_MESSAGES[raw];
		if (mapped) return mapped;
	}

	if (status === 403) {
		return 'Модуль sender отключён';
	}

	return raw ?? 'Неизвестная ошибка';
}
